import styled, {css} from "styled-components";
import {Swiper} from "swiper/react";

// 추천 슬라이드(미리보기 4개)
const RecommendButtonWrap = styled.div`
	button {
		position: absolute;
		top: 50%;
		width: 40px;
		height: 40px;
		border: 1px solid #d0d0d0;
		border-radius: 50%;
		background-color: #fff;
		transform: translateY(-50%);

		&:after {
			position: absolute;
			top: 16px;
			display: block;
			width: 6px;
			height: 6px;
			border-top: 1px solid #848484;
			border-right: 1px solid #848484;
			font-size: 0;
			content: "";
		}
		&:hover:not(:disabled) {
			background-color: #333;
			border-color: #333;
			&:after {
				border-top: 1px solid #fff;
				border-right: 1px solid #fff;
			}
		}
		&:disabled {
			border: 1px solid #e5e5e5;
			cursor: unset;
			&::after {
				border-top: 2px solid #e5e5e5;
				border-right: 2px solid #e5e5e5;
			}
		}
	}
`;
const RecommendNextbutton = styled.button`
	right: -60px;

	&:after {
		right: 17px;
		transform: rotate(45deg);
	}
`;
const RecommendPrevbutton = styled.button`
	left: -60px;
	&:after {
		left: 17px;
		transform: rotate(-135deg);
	}
`;
const RecommendSlider = styled(Swiper)`
	width: 100%;
	cursor: pointer;
`;

// 썸네일 슬라이더(미리보기 5개)
const ThumbsSlider = styled(Swiper)`
	height: 90px;
	margin-top: 20px;
	cursor: pointer;
	.swiper-slide:not(.swiper-slide-thumb-active) {
		position: relative;
		&::before {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			display: block;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5);
			content: "";
		}
	}
`;
const ThumbsSlideImg = styled.div<{types?: string}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 136px;
	height: 90px;
	background-color: #f3f3f3;
	img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	${props =>
		props.types === "movie"
			? css`
					&::before {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 45px;
						height: 45px;
						border-radius: 50%;
						background-color: rgba(0, 0, 0, 0.4);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
					&::after {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 0;
						height: 0;
						margin-left: 2px;
						border-bottom: 8px solid transparent;
						border-top: 8px solid transparent;
						border-left: 16px solid rgba(255, 255, 255, 0.8);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
			  `
			: ""}
`;
// 상품디테일 슬라이더(미리보기 3개)
const ProductDetailSlider = styled(Swiper)`
	height: 265px;
	cursor: pointer;

	.swiper-button-next,
	.swiper-button-prev {
		width: 50px;
		height: 50px;
		border: 1px solid var(--emp-color);
		background-color: rgba(34, 34, 34, 0.6);
		&:after {
			width: 18px;
			height: 18px;
			border-top: 1px solid #fff;
			border-right: 1px solid #fff;
			font-size: 0;
			content: "";
		}
		&:hover {
			background-color: rgba(255, 255, 255, 0.6);
			&:after {
				border-top: 1px solid var(--emp-color);
				border-right: 1px solid var(--emp-color);
			}
		}
	}
	.swiper-button-next {
		right: 0;
		&:after {
			margin-right: 10px;
			transform: rotate(45deg);
		}
	}
	.swiper-button-prev {
		left: 0;
		&:after {
			margin-left: 10px;
			transform: rotate(-135deg);
		}
	}
`;
const ProductDetailSlideImg = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 390px;
	height: 100%;
	background-color: #f3f3f3;
	> img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		&.img-error {
			width: 30%;
			height: auto;
		}
	}
`;

// 이미지 확대 슬라이더(미리보기 1개)
const ZoomSlider = styled(Swiper)`
	height: 495px;
	cursor: pointer;
	.swiper-pagination {
		position: absolute;
		left: auto;
		right: 10px;
		bottom: 11px;
		width: fit-content;
		padding: 5px 10px 6px;
		border-radius: 20px;
		background-color: rgba(0, 0, 0, 0.6);
		font-size: var(--small-size);
		color: #fff;
		line-height: 1;
	}
	.swiper-button-next,
	.swiper-button-prev {
		width: 50px;
		height: 50px;
		border: 1px solid var(--emp-color);
		background-color: rgba(34, 34, 34, 0.6);
		&:after {
			width: 18px;
			height: 18px;
			border-top: 1px solid #fff;
			border-right: 1px solid #fff;
			font-size: 0;
			content: "";
		}
		&:hover {
			background-color: rgba(255, 255, 255, 0.6);
			&:after {
				border-top: 1px solid var(--emp-color);
				border-right: 1px solid var(--emp-color);
			}
		}
	}
	.swiper-button-next {
		right: 0;
		&:after {
			margin-right: 10px;
			transform: rotate(45deg);
		}
	}
	.swiper-button-prev {
		left: 0;
		&:after {
			margin-left: 10px;
			transform: rotate(-135deg);
		}
	}
`;

const ZoomSlideImg = styled.div<{types?: string}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 720px;
	height: 100%;
	background-color: ${props => (props.types === "movie" ? "var(--emp-color)" : "#f3f3f3")};
	img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

// 상품디테일 슬라이더(미리보기 3개 + 이미지, 동영상)
const EventSlider = styled(Swiper)`
	height: 265px;
	cursor: pointer;

	.swiper-button-next,
	.swiper-button-prev {
		width: 50px;
		height: 50px;
		border: 1px solid var(--emp-color);
		background-color: rgba(34, 34, 34, 0.6);
		&:after {
			width: 18px;
			height: 18px;
			border-top: 1px solid #fff;
			border-right: 1px solid #fff;
			font-size: 0;
			content: "";
		}
		&:hover {
			background-color: rgba(255, 255, 255, 0.6);
			&:after {
				border-top: 1px solid var(--emp-color);
				border-right: 1px solid var(--emp-color);
			}
		}
	}
	.swiper-button-next {
		right: 0;
		&:after {
			margin-right: 10px;
			transform: rotate(45deg);
		}
	}
	.swiper-button-prev {
		left: 0;
		&:after {
			margin-left: 10px;
			transform: rotate(-135deg);
		}
	}
`;
const EventSlideImg = styled.div<{types?: string}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 390px;
	height: 100%;
	background-color: #f3f3f3;
	> img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		filter: ${props => (props.types === "movie" ? "brightness(0.7)" : "")};
		&.img-error {
			width: 30%;
			height: auto;
		}
	}

	${props =>
		props.types === "movie"
			? css`
					&::before {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 60px;
						height: 60px;
						border-radius: 50%;
						background-color: rgba(0, 0, 0, 0.4);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
					&::after {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 0;
						height: 0;
						margin-left: 2px;
						border-bottom: 12px solid transparent;
						border-top: 12px solid transparent;
						border-left: 20px solid rgba(255, 255, 255, 0.8);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
			  `
			: ""}
`;

// 호텔/리조트 슬라이드(미리보기 2개 + 이미지, 동영상)
const GuideSlider = styled(Swiper)`
	cursor: pointer;

	.swiper-pagination {
		position: absolute;
		left: auto;
		right: 10px;
		bottom: 11px;
		width: fit-content;
		padding: 5px 10px 6px;
		border-radius: 20px;
		background-color: rgba(0, 0, 0, 0.6);
		font-size: var(--small-size);
		color: #fff;
		line-height: 1;
	}
	.swiper-button-next,
	.swiper-button-prev {
		width: 50px;
		height: 50px;
		border: 1px solid var(--emp-color);
		background-color: rgba(34, 34, 34, 0.6);
		&:after {
			width: 18px;
			height: 18px;
			border-top: 1px solid #fff;
			border-right: 1px solid #fff;
			font-size: 0;
			content: "";
		}
		&:hover {
			background-color: rgba(255, 255, 255, 0.6);
			&:after {
				border-top: 1px solid var(--emp-color);
				border-right: 1px solid var(--emp-color);
			}
		}
	}
	.swiper-button-next {
		right: 0;
		&:after {
			margin-right: 10px;
			transform: rotate(45deg);
		}
	}
	.swiper-button-prev {
		left: 0;
		&:after {
			margin-left: 10px;
			transform: rotate(-135deg);
		}
	}

	.swiper-wrapper {
		min-height: 100%;
		.swiper-slide {
			height: auto;
			min-height: 100%;
		}
	}
`;

const GuideSlideImg = styled.div<{types?: string}>`
	width: 100%;
	height: 100%;
	max-height: 270px;
	background-color: #f3f3f3;
	img {
		filter: ${props => (props.types === "movie" ? "brightness(0.7)" : "")};
		&:not(.fallback_thumb) {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	${props =>
		props.types === "movie"
			? css`
					&::before {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 60px;
						height: 60px;
						border-radius: 50%;
						background-color: rgba(0, 0, 0, 0.4);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
					&::after {
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 1;
						display: block;
						width: 0;
						height: 0;
						margin-left: 2px;
						border-bottom: 12px solid transparent;
						border-top: 12px solid transparent;
						border-left: 20px solid rgba(255, 255, 255, 0.8);
						transform: translate(-50%, -50%);
						pointer-events: none;
						content: "";
					}
			  `
			: ""}
`;

export {
	RecommendButtonWrap,
	RecommendNextbutton,
	RecommendPrevbutton,
	RecommendSlider,
	ThumbsSlider,
	ThumbsSlideImg,
	ProductDetailSlideImg,
	ProductDetailSlider,
	ZoomSlider,
	ZoomSlideImg,
	EventSlider,
	EventSlideImg,
	GuideSlideImg,
	GuideSlider,
};
